import React from 'react';
import {useLocation} from "react-router-dom";
import {Sidebar, Menu, MenuItem, SubMenu} from "react-pro-sidebar";
import SidebarHeader from "./SidebarHeader";
import {isActiveLink, isActiveParentChild } from "../../../utils/linkActiveChecker";

import menuData from "../../../data/MenuData";

const Index = ({ show, onClose }) => {
  const router = useLocation();
  const fullPathWithHash = `${router.pathname}${router.hash}`;

  return (
    <div
      className={`offcanvas offcanvas-start mobile_menu-content ${show ? "show" : ""}`}
      tabIndex="-1"
      id="offcanvasMenu"
      data-bs-scroll="true"
    >
      <SidebarHeader onClose={onClose}/>

      <Sidebar>
        <Menu>
          {menuData.map((category) => (
                  category.items && category.items.length > 0 ? (
                          <SubMenu
                                  key={category.id}
                                  component="div"
                                  label={category.label}
                                  className={
                                    isActiveParentChild(category.items, fullPathWithHash)
                                            ? "menu-active"
                                            : ""
                                  }
                          >
                            {category.items.map((menuItem, i) => (
                                    <MenuItem
                                            key={i}
                                            className={
                                              isActiveLink(menuItem.routePath, fullPathWithHash)
                                                      ? "menu-active-link"
                                                      : ""
                                            }
                                            component={<a href={menuItem.routePath}>{menuItem.label}</a>}
                                            onClick={onClose}
                                    >
                                      {menuItem.name}
                                    </MenuItem>
                            ))}
                          </SubMenu>
                  ) : (
                          <MenuItem
                                  key={category.id}
                                  className={
                                    isActiveLink(category.routePath, fullPathWithHash)
                                            ? "menu-active-link"
                                            : ""
                                  }
                                  component={<a href={category.routePath}>{category.label}</a>}
                                  onClick={onClose}
                          >

                            {category.icon ? (
                                isActiveLink(category.routePath, fullPathWithHash)
                                    ? <img src={category.iconActive} alt={category.label} width="20" />
                                    : <img src={category.icon} alt={category.label} width="20" />
                            ) : (
                                category.label
                            )}
                          </MenuItem>
                  )
          ))}
        </Menu>
      </Sidebar>
    </div>
  );
};

export default Index;
